import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import {
  getUserRole,
  getTranslationsByScope,
  DropitState,
  getUserSelectedSupplier,
  getTechPropNodes,
  getComPropNodes,
} from "../../core/reducers"

import View, { IProductFormProps } from "./viw_product-form-temp"
import { getActiveLang } from "../../core/reducers"
import { getActions, ProductFormActions } from "./_actions"
import * as React from "react"
import { fetchProducts, goToProduct, goToProductList } from "../../core/actions"
import { getProductList } from "../../core/reducers/red_products"

// Every value returned here must keep its reference when unchanged: react-redux re-renders the whole form as
// soon as one of them differs (FE-PERF-F03).
const mapStateToProps = (state: DropitState, ownProps: any) => {
  return {
    formId: ownProps.match.params.id,
    declinedId: ownProps.match.params.declinedid,
    selectedSupplier: getUserSelectedSupplier(state),
    activeLang: getActiveLang(state),
    role: getUserRole(state),
    translations: getTranslationsByScope(state, "productForm"),
    errorTranslations: getTranslationsByScope(state, "fieldErrors"),
    techPropNodes: getTechPropNodes(state),
    techRawData: state.miscellaneous.techTree.rawData,
    comPropNodes: getComPropNodes(state),
    comRawData: state.miscellaneous.comTree.rawData,
    vat: state.miscellaneous.vat,
    warrantyOptionList: state.miscellaneous.warranty,
    taxes: state.miscellaneous.taxes,
    customs: state.miscellaneous.customs,
    territoi: state.miscellaneous.territoi,
    brands: state.miscellaneous.brands,
    state: state.productForm,
    products: getProductList(state),
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  actions: getActions(dispatch),
  goToProduct: (formId: string, declined?: string) =>
    dispatch(goToProduct(formId, declined)),
  goToProductList: () => dispatch(goToProductList()),
  fetchProducts: () => dispatch(fetchProducts()),
})

const SafeGuard = (props: IProductFormProps) => {
  const displayable = !!props.state.dataByFormId[props.formId]
  if (!displayable) {
    props.actions._initFormId(props.formId)
  }

  return <>{displayable && <View {...props} />}</>
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SafeGuard)
)
